import { Component, type ErrorInfo, type ReactNode } from "react";

type Props = {
  children: ReactNode;
  /** Optional label for the recovery message. */
  label?: string;
};

type State = {
  error: Error | null;
};

/**
 * Catches render/lifecycle crashes (e.g. TipTap after scene remount) so the
 * whole app does not disappear into an empty #root.
 */
export class EditorErrorBoundary extends Component<Props, State> {
  state: State = { error: null };

  static getDerivedStateFromError(error: Error): State {
    return { error };
  }

  componentDidCatch(error: Error, info: ErrorInfo) {
    console.error("Editor crash:", error, info.componentStack);
  }

  render() {
    if (!this.state.error) return this.props.children;
    const label = this.props.label ?? "editoren";
    return (
      <div className="sm-editor-error" role="alert">
        <p>
          Noget gik galt i {label}. Prøv at fortsætte — eller genindlæs siden,
          hvis problemet bliver ved.
        </p>
        <div className="sm-editor-error-actions">
          <button
            type="button"
            onClick={() => this.setState({ error: null })}
          >
            Prøv igen
          </button>
          <button type="button" onClick={() => window.location.reload()}>
            Genindlæs siden
          </button>
        </div>
      </div>
    );
  }
}
